const __WEBPACK_NAMESPACE_OBJECT__ = window.styled["6.6.0"];